import React, { useContext } from "react";

import { Dropdown } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";

export default function FundsDashboardRecord({ data }) {
	const totalFamiliesRecord = [
		{
			icon: "card_membership",
			trend: "card_membership",
			title: "TOTAL AMOUNT RECEIVED",
			variant: "green",
			number: "32,500",
			percent: 95,
		},
		{
			icon: "price_change",
			trend: "price_change",
			title: "TOTAL RELEASE AMOUNT",
			variant: "blue",
			number: "5,00",
			percent: 30,
		},
		{
			icon: "account_balance_wallet",
			trend: "account_balance_wallet",
			title: "TOTAL BALANCE AMOUNT",
			variant: "purple",
			number: "32,000",
			percent: 25,
		},
		{
			icon: "account_balance_wallet",
			trend: "account_balance_wallet",
			title: "TOTAL REQUEST IDs",
			variant: "blue",
			number: "3,000",
			percent: 25,
		},
		{
			icon: "account_balance_wallet",
			trend: "account_balance_wallet",
			title: "Families Set Free",
			variant: "blue",
			number: "32,000",
			percent: 25,
		},
		{
			icon: "account_balance_wallet",
			trend: "account_balance_wallet",
			title: "Matthew 10",
			variant: "blue",
			number: "32,000",
			percent: 25,
		},
	];
	return (
		<>
			{totalFamiliesRecord.map((data) => {
				return (
					<Col md={4}>
						<div
							className={`mc-ecommerce-card ${data.variant}`}
							style={{
								background:
									"linear-gradient(to right, rgba(0,0,0,0.8), #077834)",
							}}
						>
							<i
								className="mc-ecommerce-card-trend material-icons"
								style={{ color: "#077834" }}
							>
								{data.trend}
							</i>
							<div className="mc-ecommerce-card-head">
								<h4 className="mc-ecommerce-card-meta">
									<span>{data.title}</span>
									{data.number}
								</h4>
								<i
									className=" material-icons"
									style={{ color: "#077834", width: "12px" }}
								>
									{data.icon}
								</i>
							</div>
							<div className="mc-ecommerce-card-foot">
								<div className="mc-ecommerce-card-compare">
									{/* <mark>+ { percent }%</mark> */}
								</div>
							</div>
						</div>
					</Col>
				);
			})}
		</>
	);
}
